import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  FormGroup,
  Button,
  Alert,
  InputGroup,
  InputGroupAddon,
  Spinner,
  UncontrolledAlert,
} from "reactstrap";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvFeedback,
} from "availity-reactstrap-validation";
import { User, Mail } from "react-feather";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";
import Cookies from "js-cookie";

class ContactDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      isOpen: false,
    };
    this.cookieCheckInterval = null;
  }

  componentDidMount() {
    // Set a timer to open dialog after 1 second
    this.timer = setTimeout(() => {
      this.setState({ isOpen: true });
    }, 1000);

    // Check every 0.5 seconds
    this.cookieCheckInterval = setInterval(() => {
      //const keepInform = Cookies.get("keepinform");
      const keepInform = localStorage.getItem('keepinform')

      if (keepInform != null) {
        this.setState({ isOpen: false });
      }
    }, 500);
  }

  componentWillUnmount() {
    // Clear timer if component unmounts
    clearTimeout(this.timer);

    // Clean up interval
    if (this.cookieCheckInterval) {
      clearInterval(this.cookieCheckInterval);
    }
  }

  componentDidUpdate(prevProps) {
    // Update state when props change
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({ isOpen: this.props.isOpen });
    }
  }

  openDialog = () => {
    this.setState({ isOpen: true });
    if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  closeDialog = () => {
    this.setState({ isOpen: false, isDisabled: true });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleSendMessage = (event, { firstName, lastName, email, isPro }) => {
    //alert(`${firstName} ${lastName} ${email} ${isPro}`);
    this.setState({ isOpen: false });
    if (this.props.handleSendMessage) {
      this.props.handleSendMessage(event, { firstName, lastName, email, isPro});
    }
  };

  render() {
    const { isOpen } = this.state;
    const { title, children } = this.props;

    //if (!isOpen) return null;
    const { t } = this.props;

    return (
      <div className="dialog-overlay"
      style={{ opacity: isOpen ? 1 : 0,
          transition: "opacity 1.0s ease-in-out",
                           }}>
        <div className="dialog-content">
          <div className="dialog-header">
            <button onClick={this.closeDialog} className="dialog-close-button">
              &times;
            </button>
          </div>
          <div className="dialog-body">
            <AvForm
              onValidSubmit={this.handleSendMessage}
              onInvalidSubmit={(event, errors, values) => {
                console.log("Invalid fields:", errors); // Debug invalid inputs
              }}
              className="authentication-form mt-20"
            >
               
                      <p className="text-left-important text-blod-description">
                        {t(
                          "We promise not to overflow your inbox. By registering here, expect occasional news about our progress, when the app is ready for you to download, and other key information along the way!"
                        )}
                      </p>

              {/* <Row>
                <Col>
                  <Label className="text-color mb-0 ">
                    Just fill in this form and we’ll keep you informed about
                    launch updates and key information.
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Label className="text-color mb-1 ">
                    Good to know: at EcoShift, your data is safe and will not
                    shared.
                  </Label>
                </Col>
              </Row> */}
              
              <Row className="mt-2">
                <Col>
                  <AvGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <span className="input-group-text">
                          <User className="icon-dual" />
                        </span>
                      </InputGroupAddon>
                      <AvInput
                        type="text"
                        name="firstName"
                        value={this.state.firstName}
                        placeholder={t("First Name")}
                        onChange={(e) =>
                          this.setState({ firstName: e.target.value })
                        }
                        required
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t("This field is invalid"),
                          },
                        }}
                        className={this.state.showAllErrors ? "is-invalid" : ""}
                      />
                      <AvFeedback>{t("This field is invalid")}</AvFeedback>
                    </InputGroup>
                  </AvGroup>
                </Col>
              </Row>

              <Row>
                <Col>
                  <AvGroup>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <span className="input-group-text">
                          <User className="icon-dual" />
                        </span>
                      </InputGroupAddon>
                      <AvInput
                        type="text"
                        name="lastName"
                        value={this.state.lastName}
                        placeholder={t("Last Name")}
                        onChange={(e) =>
                          this.setState({ lastName: e.target.value })
                        }
                        required
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t("This field is invalid"),
                          },
                        }}
                        className={this.state.showAllErrors ? "is-invalid" : ""}
                      />
                      <AvFeedback>{t("This field is invalid")}</AvFeedback>
                    </InputGroup>
                  </AvGroup>
                </Col>
              </Row>

              <Row>
                <Col>
                  <AvGroup className="mb-3">
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <span className="input-group-text">
                          <Mail className="icon-dual" />
                        </span>
                      </InputGroupAddon>
                      <AvInput
                        type="email"
                        name="email"
                        value={this.state.email}
                        placeholder={t("Email address")}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                        required
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t("This field is invalid"),
                          },
                        }}
                        className={this.state.showAllErrors ? "is-invalid" : ""}
                      />
                      <AvFeedback>{t("This field is invalid")}</AvFeedback>
                    </InputGroup>
                  </AvGroup>
                </Col>
              </Row>

              <Row>
                <Col>
                
                <p class="mt-1 text-blod-description">
                    {t(
                      "Optional info:"
                    )}
                    </p>
                  <label class="checkbox-wrapper text-blod-description">
                    {t(
                      "I am an eco-certified professional, and would also like to know more about how to register my business on the platform."
                    )}
                    <AvInput
                      type="checkbox"
                      name="isPro"
                      value={this.state.isPro}
                      onChange={(e) => this.setState({ isPro: e.target.value })}
                    />
                    <span class="checkbox-custom"></span>
                  </label>
                  {/* <p class="checkbox-wrapper">
                    {t(
                      "(This field is optional)"
                    )}
                    </p> */}
                </Col>
              </Row>
          
              <FormGroup className="form-group mb-0 mt-2 text-center">
                <div className="row align-items-center justify-content-center">
                  <Button
                    className="btn-default custom"
                    type="submit"
                    value="submit"
                    name="submit"
                    id="mc-embedded-subscribe"
                    disabled={this.state.isDisabled}
                  >
                    {t("Send")}
                  </Button>
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ContactDialog);
